import queryString from 'query-string';
import React, { useEffect, useMemo, useState } from 'react';
import microcopyGroupIds from '../../../components/pge-plus-common/microcopyGroupIds';
import useContentMgmt from '../../../hooks/useContentMgmt';
import useWrapWithLoader from '../../../hooks/useWrapWithLoading';
import { useMutation } from '@apollo/react-hooks';
import { rejectInvoicePoratlUserUserRegistrationMutation } from '../../../hooks/invoice-payment-portal/useInvoicePaymentRegistration';
import { InvoicePortalRejectUserRegistrationResponse } from '../../../__generated__/pge-types';
import { Card, CardContent, styled, Typography } from '@material-ui/core';
import useUtil from '../../../hooks/invoice-payment-portal/useUtil';

const PREFIX = 'Login';

const classes = {
  card: `${PREFIX}-card`,
  cardContent: `${PREFIX}-cardContent`,
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.card}`]: {
    padding: '4em 5em',
    [theme.breakpoints.down('sm')]: {
      padding: '4em 2em',
    },
  },
  [`& .${classes.cardContent}`]: {
    display: 'flex',
    flexDirection: 'column',
    padding: 0,
  },
}));

const RegisterationRejected = () => {
  const { content } = useContentMgmt(microcopyGroupIds.INVOICE_PAYMENT_SIGN_IN);
  const [registerationRejected, setRegisterationRejected] =
    useState<boolean>(false);

  const { wrapWithLoader } = useWrapWithLoader();

  const { setErrorNotification } = useUtil();
        
  const queryParams = useMemo(() => {
    if (typeof window === 'undefined') {
      return {};
    }
    return queryString.parse(window.location.search);
  }, [typeof window !== 'undefined' ? window.location.search : '']);
 
  const [rejectInvoicePaymentUserRegistration] = useMutation<{
    rejectInvoicePortalUserRegistration: InvoicePortalRejectUserRegistrationResponse;
  }>(rejectInvoicePoratlUserUserRegistrationMutation);

  useEffect(() => {
    const rejectRegisteration = wrapWithLoader(async () => {
      try {
        const { data: registerData } = await rejectInvoicePaymentUserRegistration({
          variables: {
            payload: {
              token: encodeURIComponent(queryParams?.token as string).replace(
                /%20/g,
                '%2B',
              ),
            },
          },
        });
        if (registerData?.rejectInvoicePortalUserRegistration?.isSuccess) {
          setRegisterationRejected(true);
        }
        window.scrollTo(0, 0);
      } catch (e) {
        setErrorNotification(
          true,
          content.get('GENERIC_ERROR_NOTIFICATION_MESSAGE'),
        );
      }
    });
    if (queryParams?.token) {
      void rejectRegisteration();
    }
  }, [queryParams?.token]);

  return (
    <Root>
      <Card className={classes.card}>
        <CardContent className={classes.cardContent}>
          {registerationRejected && (
            <>
              <Typography variant={'h1'}>
                {content.get('REGISTRATION_REJECTED')}
              </Typography>
              <Typography variant={'body1'}>
                {content.get('INVOICE_PAYMENT_USER_REGISTRATION_REJECTED')}
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </Root>
  );
};
export default RegisterationRejected;
